import config from '../baseConfig/index';

export default {
    LOGIN: config.urlPrefix,
    REGISTER: config.urlPrefix + 'register',
    FORGOT_PASSWORD_B2C: config.urlPrefix + 'forgot-password-b2c',
    FORGOT_PASSWORD_B2B: config.urlPrefix + 'forgot-password-b2b',
    PROFILE: config.urlPrefix + 'profile',
    B2B: config.urlPrefix + 'b2b'
};